export function calculaValorFinalProduto(
	produto,
	desconto = undefined,
	valor_tabela = undefined,
	quantidade = undefined
) {
	const descontoCalculo = desconto === undefined ? produto.desconto : desconto;
	const valor_tabelaCalculo =
		valor_tabela === undefined ? produto.valor_tabela : valor_tabela;

	let quantidadeCalculo = undefined;

	if (quantidade !== undefined) {
		quantidadeCalculo = quantidade;
	} else {
		quantidadeCalculo =
			typeof produto.quantidade === "number"
				? produto.quantidade
				: produto.amount;
	}

	return -(
		(valor_tabelaCalculo * quantidadeCalculo * descontoCalculo) / 100 -
		valor_tabelaCalculo * quantidadeCalculo
	);
}
export function calculaValorUnitarioFinalProduto(
	produto,
	desconto = undefined,
	valor_tabela = undefined
) {
	const descontoCalculo = desconto === undefined ? produto.desconto : desconto;
	const valor_tabelaCalculo =
		valor_tabela === undefined ? produto.valor_tabela : valor_tabela;
	return -((valor_tabelaCalculo * descontoCalculo) / 100 - valor_tabelaCalculo);
}
